import { Navigate } from 'react-router-dom';

import Pages from '@/pages';

// Deep links return through /api/login?returnUrl=... server-side now (GSB-7560); this route
// only keeps old bookmarks of the former OIDC callback landing on the start page.
const AuthLanding = () => <Navigate to={Pages.ROOT} replace />;

export default AuthLanding;
